import { BREAKPOINT_ORDER } from "./Breakpoint";
import type { Dimensions } from "../Dimensions";
import { transformBreakpointToCSSMediaQuery } from "./transformers/transformBreakpointToCSSMediaQuery";

/**
 * Generates CSS styles for an array of values with respect to breakpoints.
 * @param {number | number[] | Dimensions | Dimensions[]} values - The values to generate styles for.
 * @param {(value: number | Dimensions) => string} cssProperty - A function that takes a value and returns its corresponding CSS property string.
 * @returns {string} - The generated CSS string.
 */
export const getStylesWithBreakpoints = (
    values: number | number[] | Dimensions | Dimensions[],
    cssProperty: (value: number | Dimensions) => string,
): string => {
    const valuesArray = Array.isArray(values) ? values : [values];
    return valuesArray
        .map((value, index) => {
            const propertyValue = cssProperty(value);
            return index === 0
                ? propertyValue
                : `
              ${transformBreakpointToCSSMediaQuery(BREAKPOINT_ORDER[index], "up")} {
                  ${propertyValue}
              }
            `;
        })
        .join("");
};
